module.exports = __webpack_public_path__ + "static/img/manual-5.21e8861.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-5.png
// module id = aHtF
// module chunks = 4